
import React, { useState } from 'react'
import { API, Submit, Input, Date, useSubmit, Card, Pagination, Table, useGet, Filter, Help, notify, useDelete, cashmoneyhelper } from '@enkla-gui'
import Modal from 'react-modal'
import { icons, filters } from '@config'
import { useForm } from 'react-hook-form'

export default function RentAdjustmentTable({ entity }) {

  const [selected, setSelected] = useState(false)
  const [createModal, setCreateModal] = useState(false)
  const { data, fetch, loading, setPage, sorting, setSorting } = useGet({ endpoint: `api/rentadjustment`, filter: { entity: entity.id } })

  let { remove } = useDelete({
    endpoint: `api/rentadjustment/`,
    success: () => fetch()
  })
  const { register: createRegister, submit: createSubmit, control: createControl, loading: createLoading, error: createError, reset: createReset, watch: createWatch } = useSubmit({
    endpoint: `api/rentadjustment/single`,
    success: () => {
      setCreateModal(false)
      createReset()
      fetch()
    }
  })
  const createRate = createWatch('rate', 0)
  const { register, submit, setValue, watch, getValues, loading: updateLoading, error, control } = useSubmit({
    endpoint: `api/rentadjustment`,
    form: selected,
    method: 'patch',
    success: _ => {
      setSelected(false)
      fetch()
    }
  })
  return (
    <>
      <Card title='Hyresjusteringar' icon={icons.percent} collapsed={data?.data?.length === 0}
        buttons={{
          header: [{ icon: 'fas fa-plus-square', text: 'Skapa', callback: () => setCreateModal(true) }]
        }}>
        <Table
          rows={data?.data}
          fetching={loading}
          useSorting={sort => setSorting({ ...sort })}
          sorting={sorting}
          empty={{
            text: 'Det finns inga hyresjusteringar, skapa en från sidomenyn',
            icon: icons.percentage
          }}
          functions={{
            delete: ra => remove(ra.id),
            edit: ra => ra.status === 'SCHEDULED' ? setSelected(ra) : notify.toast("Du kan bara redigera schemalagda justeringar", "warning"),
            status: status => status === 'SCHEDULED' ? <span class={`badge bg-warning w-100`}> Schemalagd </span> : <span class={`badge bg-success w-100`}> Utförd</span>
          }}
          keys={['_this>button:edit:fa-edit', 'status>function:status', 'rate>%', 'scheduled_at>date:short', 'executed_at>date:short', '_this>button:delete:fa-trash']}
          headers={[
            {
              class: 'min',
            },
            {
              value: 'Status',
              key: 'status',
              class: 'min'
            },
            {
              value: 'Förändring (%)',
              key: 'rate'
            },
            {
              value: 'Schemalagd',
              ifnull: 'Utfördes direkt',
              key: 'scheduled_at'
            },
            {
              value: 'Utförd',
              ifnull: 'Väntar på att utföras',
              key: 'executed_at',
              sortable: true
            },
            {
              class: 'min',
            },
          ]}
        />
        <Pagination data={data} fetch={setPage} />
      </Card>

      <Modal isOpen={createModal} onRequestClose={() => setCreateModal(false)} className='no-padding'
        buttons={{
          header: [{ callback: () => setCreateModal(false), icon: 'fas fa-times', text: 'Avbryt', bg: 'light' }],
        }}
      >
        <Card title="Skapa hyresjustering" icon={icons.percent} collapsed={null} buttons={{
          footer: [<Submit onSubmit={createSubmit} text='Skapa' sending={createLoading} />]
        }}>
          <input type='hidden' {...createRegister('entity_id')} value={entity.id} />
          <div class='row mb-3'>
            <div class='col'>
              <Input controls={{ register: createRegister }} name='rate' options={{ required: true }} label='Förändring (%)' type='number' error={createError} />
            </div>
          </div>
          <div class='row mb-3'>
            <div class='col'>
              <Date label='Datum' placeholder="Om inget anges utförs justeringen direkt" controls={{ control: createControl }} name='scheduled_at' error={createError} />
            </div>
          </div>
          <Help header={false} icon={false}>
            <div class='row'>
              <div class='col'>
                <div class='mb-2'>
                  <strong>Nuvarande hyra:</strong> {cashmoneyhelper.format(entity.fee)}
                </div>
                <div>
                  <strong>Ny hyra:</strong> {cashmoneyhelper.format(parseInt(entity.fee + entity.fee * (createRate / 100)))}
                </div>
              </div>
            </div>
          </Help>
        </Card>
      </Modal>

      <Modal isOpen={selected} onRequestClose={() => setSelected(false)} className='no-padding'
        buttons={{
          header: [{ callback: () => setSelected(false), icon: 'fas fa-times', text: 'Avbryt', bg: 'light' }],
        }}
      >
        <Card title="Redigera hyresjustering" icon={icons.edit} collaptsed={null} buttons={{
          footer: [<Submit onSubmit={submit} text='Uppdatera' sending={updateLoading} />]
        }}>
          <div class='row mb-3'>
            <div class='col'>
              <Input controls={{ register }} name='rate' options={{ required: true }} label='Förändring (%)' type='number' error={error} />
            </div>
            <div class='col'>
              <Date label='Datum' placeholder="Om inget anges utförs justeringen direkt" controls={{ control }} name='scheduled_at' error={error} />
            </div>
          </div>
        </Card>
      </Modal>
    </>
  )
}
